import * as React from 'react';
export const arcSvg = React.forwardRef(function arcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M5 15.5C5 9.701 9.701 5 15.5 5S26 9.701 26 15.5v10.2a.3.3 0 0 1-.3.3h-5.4a.3.3 0 0 1-.3-.3V15.5a4.5 4.5 0 1 0-4.5 4.5h3.45a.3.3 0 0 1 .3.3v5.4a.3.3 0 0 1-.3.3H15.5C9.701 26 5 21.299 5 15.5Z',
    }),
  );
});
arcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var arc = {
  category: 'brand',
  colorable: false,
  name: 'arc',
  svg: arcSvg,
};
